import PropTypes from 'prop-types'
import axios from 'axios'
import { useEffect, useState } from 'react'
import Confirmation from '../Confirmation'
import {
  FormHelperText,
  Select,
  FormControl,
  MenuItem,
  DialogActions,
  Button,
  DialogContent,
} from '@mui/material'
import { handleOpenAlert } from '../../../../lib/handleAlert'
import eventBus from '../../../../lib/eventBus'
import { closePopup } from '../../../../store/popupsSlice'
import { useDispatch } from 'react-redux'
const ExaminationFileEdit = ({ id, romexisId, type }) => {
  const dispatch = useDispatch()

  const [files, setFiles] = useState([])
  const [fileId, setFileId] = useState(null)
  const [validate, setValidate] = useState(false)
  const [sweetAlert, setSweetAlert] = useState(false)

  useEffect(() => {
    axios.post(`/examinations/${id}/alternatives`).then((res) => {
      if (res.status == 200) {
        setFileId(romexisId)
        setFiles(res.data)
      }
    })
  }, [id])

  const submit = async () => {
    await setValidate(true)
    let elements
    setTimeout(() => {
      elements = document.querySelectorAll(
        '.Mui-error .MuiOutlinedInput-notchedOutline'
      )
    }, 100)
    setTimeout(() => {
      if (elements.length == 0) {
        setSweetAlert(true)
      }
    }, 200)
  }

  const send = () => {
    axios
      .post(`/examinations/${id}/replace`, {
        file_id: fileId,
      })
      .then((res) => {
        if (res.status == 200) {
          dispatch(closePopup('examination-file-edit-popup'))
          eventBus.dispatch('refreshExaminationFile', {
            id: id,
            romexis_id: fileId,
            type,
          })

          handleOpenAlert({
            title: 'Sukces!',
            subtitle: 'Zmieniono zdjęcie!',
            type: 'success',
          })
        }
      })
      .catch((err) => {
        handleOpenAlert(err.request.status)
      })
  }

  return (
    <>
      <DialogContent dividers={true}>
        <FormControl fullWidth error={validate && !fileId}>
          <Select value={fileId} onChange={(e) => setFileId(e.target.value)}>
            {files &&
              files.map((option) => (
                <MenuItem key={option.romexis_id} value={option.romexis_id}>
                  {option.name} - {option.dap}
                </MenuItem>
              ))}
          </Select>
          {validate && !fileId && (
            <FormHelperText>Zdjęcie jest wymagane</FormHelperText>
          )}
        </FormControl>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            onClick={() => submit()}
          >
            Zapisz
          </Button>
        </DialogActions>
        {sweetAlert && (
          <Confirmation
            level={5}
            maxWidth="xs"
            icon="Warning"
            title={`Czy na pewno chcesz zmienić plik?`}
            subtitle={`Ta operacja nie jest odwracalna.`}
            reject={() => {
              setSweetAlert(false)
            }}
            success={async () => send()}
          />
        )}
      </DialogContent>
    </>
  )
}

ExaminationFileEdit.propTypes = {
  id: PropTypes.string,
  romexisId: PropTypes.string,
  type: PropTypes.string,
}

export default ExaminationFileEdit
